<template>
  <b-row>
    <b-col cols="12">
      <b-form-group label="ผู้ประกอบธุรกิจ (ผู้ถูกร้องทุกข์)">

        <b-form-input
          v-if="comp.companyName != null && !isEdit"
          v-model="comp.companyName"
          :value="comp.companyName"
          readonly
          class="col-6"
        />
        <b-row v-else>
          <vue-autosuggest
            v-model="comp.companyName"
            :suggestions="filteredOptions"
            :limit="limit"
            :input-props="inputProps"
            class="col-6"
            @selected="onSelected"
            @input="onInputChange"
          >
            <template slot-scope="{suggestion}">
              <span class="my-suggestion-item">{{ suggestion.item.name }}</span>
            </template>
          </vue-autosuggest>
          <!-- <b-button v-if="isEdit" @click="onA" class="col-2 ml-1" variant="outline-primary">แก้ไข</b-button> -->
          <b-button
            v-if="typeof(ReadOnly) === 'undefined' && IsDeleteAble === true"
            class="col-2 ml-1"
            variant="danger"
            @click="onDeleteBtnClicked"
          >ลบ</b-button>
        </b-row>
      </b-form-group>
    </b-col>
    <b-col cols="12">
      <b-form-group label="ที่อยู่/รายละเอียดเพิ่มเติม ผู้ประกอบธุรกิจ (ผู้ถูกร้องทุกข์)">
        <span class="text-danger">**โปรดระบุข้อมูลอย่างละเอียด เพื่อความรวดเร็วในการดำเนินการของเจ้าหน้าที่</span>
        <b-form-textarea
          v-model="comp.companyDetail"
          placeholder="ที่อยู่/รายละเอียดเพิ่มเติม ผู้ประกอบธุรกิจ (ผู้ถูกร้องทุกข์)"
          :v-text="selected"
          :readonly="!isEdit"
          rows="3"
        />
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import {
  BFormGroup, BRow, BCol, BFormTextarea, BButton, BFormInput,
} from 'bootstrap-vue'
import { VueAutosuggest } from 'vue-autosuggest'

export default {
  components: {
    BFormInput,
    BButton,
    BFormGroup,
    BRow,
    BCol,
    BFormTextarea,
    VueAutosuggest,
  },
  props: {
    company: {
      type: Object,
      required: true,
    },
    edit: {
      type: Boolean,
      required: false,
      default: true,
    },
    IsReadOnly: 0,
    IsDeleteAble: false,
  },
  setup(props) {
    return {
      comp: props.company,
      isEdit: props.edit,
      selected: props.company.companyDetail,
      index: props.company.id,
      ReadOnly: props.IsReadOnly,
    }
  },
  data() {
    return {

      datasuggest: [],
      filteredOptions: [],
      inputProps: {
        id: 'companyName',
        class: 'form-control',
        placeholder: 'ผู้ประกอบธุรกิจ (ผู้ถูกร้องทุกข์)',
      },
      limit: 10,
    }
  },
  created() {
    this.$http.get('/autosuggest/data')
      .then(res => { this.datasuggest = res })
  },
  methods: {
    onSelected(option) {
      this.selected = option.item.name
      console.log(option)
      this.$emit('handle-value-selected', this.index, option.item.name)
    },
    onDeleteBtnClicked() {
      this.$emit('handle-del-btn', this.index)
    },
    onInputChange(text) {
      if (text === '' || text === undefined) {
        return
      }

      /* Full control over filtering. Maybe fetch from API?! Up to you!!! */
      const filteredCompany = this.datasuggest.data[0].company.filter(item => item.name.toLowerCase().indexOf(text.toLowerCase()) > -1).slice(0, this.limit)
      this.filteredOptions = [{
        data: filteredCompany,
      }]
    },
  },
}

</script>

 <style lang="scss" >
 @import '@core/scss/vue/libs/vue-autosuggest.scss';
</style>
